// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.app,
.content {
  height: 100%;
  width: 100%;
  font-family: 'Source Sans Pro', sans-serif;
}

.app {
  display: flex;
  position: relative;
}

::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f3f3f3;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0C0B17;
  border-radius: '6px'
}

/* Handle on Hover */
::-webkit-scrollbar-track:hover {
  background: #14131F;
}


.TableBody {
  overflow-x: auto;
}

.TableBody::-webkit-scrollbar {
  width: 6px;
}

.TableBody::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;
}
.datepicker-container {
  display: flex;
  justify-content: flex-end;
}


.custom-datepicker {
  width: 100%;
  height: auto;
  margin-left: 0;
  padding: 13px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
  color: #B2EBF2;
}

.custom-datepicker::placeholder {
  color: #B2EBF2; /* Placeholder text color */
}

.custom-datepicker-calendar {
  background-color: #008080; /* Calendar background color */
  color: #FFFFFF; /* Calendar text color */
}

.custom-datepicker-calendar .react-datepicker__day:hover {
  background-color: #005f5f; /* Hover color for days */
}

body {
  overflow: hidden; /* Hide the scrollbar of the entire page */
}

.apexcharts-toolbar {
  background: 'transparent';
  border: 1px solid 'transparent';
  border-radius: 4px;
  color: #0f0c29;
}

.apexcharts-toolbar svg {
  fill: #0f0c29; /* Change icon color */
}

.apexcharts-toolbar button {
  background: transparent;
  color: #B2EBF2;
}

.apexcharts-toolbar button:hover {
  background: #444;
  color: #B2EBF2;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB;AACF;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@600&display=swap');\n\nhtml,\nbody,\n#root,\n.app,\n.content {\n  height: 100%;\n  width: 100%;\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\n.app {\n  display: flex;\n  position: relative;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f3f3f3;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #0C0B17;\n  border-radius: '6px'\n}\n\n/* Handle on Hover */\n::-webkit-scrollbar-track:hover {\n  background: #14131F;\n}\n\n\n.TableBody {\n  overflow-x: auto;\n}\n\n.TableBody::-webkit-scrollbar {\n  width: 6px;\n}\n\n.TableBody::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 6px;\n}\n.datepicker-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n\n.custom-datepicker {\n  width: 100%;\n  height: auto;\n  margin-left: 0;\n  padding: 13px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #B2EBF2;\n}\n\n.custom-datepicker::placeholder {\n  color: #B2EBF2; /* Placeholder text color */\n}\n\n.custom-datepicker-calendar {\n  background-color: #008080; /* Calendar background color */\n  color: #FFFFFF; /* Calendar text color */\n}\n\n.custom-datepicker-calendar .react-datepicker__day:hover {\n  background-color: #005f5f; /* Hover color for days */\n}\n\nbody {\n  overflow: hidden; /* Hide the scrollbar of the entire page */\n}\n\n.apexcharts-toolbar {\n  background: 'transparent';\n  border: 1px solid 'transparent';\n  border-radius: 4px;\n  color: #0f0c29;\n}\n\n.apexcharts-toolbar svg {\n  fill: #0f0c29; /* Change icon color */\n}\n\n.apexcharts-toolbar button {\n  background: transparent;\n  color: #B2EBF2;\n}\n\n.apexcharts-toolbar button:hover {\n  background: #444;\n  color: #B2EBF2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
